import React from 'react';
import './ApproachSection.css';

const approachSteps = [
  {
    number: '01',
    title: 'Assess',
    description: 'Comprehensive diagnostic of your current talent architecture and organizational capabilities.'
  },
  {
    number: '02',
    title: 'Design',
    description: 'Customized solutions tailored to your industry, growth stage, and strategic objectives.'
  },
  {
    number: '03',
    title: 'Implement',
    description: 'Hands-on execution and change management to ensure adoption and sustainable transformation.'
  },
  {
    number: '04',
    title: 'Optimize',
    description: 'Continuous measurement against clear ROI metrics with ongoing refinement and improvement.'
  }
];

const ApproachSection = () => {
  return (
    <section id="approach" className="approach-section">
      <div className="approach-container">
        <h2 className="section-title">Our Approach</h2>
        <p className="section-subtitle">A proven methodology that drives strategic talent solutions</p>
        
        <div className="approach-grid">
          {approachSteps.map((step, index) => (
            <div key={index} className="approach-card">
              <div className="approach-number">{step.number}</div>
              <h3 className="approach-title">{step.title}</h3>
              <p className="approach-description">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ApproachSection;